<main class="login-shell">
  <header class="login-header">
    <a class="login-brand" href="/" aria-label="RAM">
      <img class="brand-mark" src="/brand/ram-leaf.png" alt="" aria-hidden="true" />
      <span class="login-brand-name">RAM</span>
      <span class="login-brand-subtitle">Real Acequia de Moncada</span>
    </a>
  </header>

  @if (showCertificateCallback) {
    <app-certificate-callback
      [error]="certificateCallbackError"
      [loading]="certificateCallbackLoading"
      (backRequested)="certificateBackRequested.emit()"
    ></app-certificate-callback>
  } @else if (!showIrrigatorAuth && !showGuardAuth && !showManagerAuth) {
    <app-profile-selection
      [loginOptions]="loginOptions"
      [profileIconPaths]="profileIconPaths"
      (profileSelected)="profileSelected.emit($event)"
    ></app-profile-selection>
  } @else if (showIrrigatorAuth) {
    <app-irrigator-auth
      (authenticated)="authenticated.emit($event)"
      (backRequested)="backToProfileSelectionRequested.emit()"
    ></app-irrigator-auth>
  } @else if (showGuardAuth) {
    <app-guard-auth
      (authenticated)="authenticated.emit($event)"
      (backRequested)="backToProfileSelectionRequested.emit()"
    ></app-guard-auth>
  } @else {
    <app-manager-auth
      (authenticated)="authenticated.emit($event)"
      (backRequested)="backToProfileSelectionRequested.emit()"
    ></app-manager-auth>
  }

  <app-site-footer />
</main>
